import { render, staticRenderFns } from "./MpDraw03V2.vue?vue&type=template&id=8904e1c4&scoped=true&"
import script from "./MpDraw03V2.vue?vue&type=script&lang=js&"
export * from "./MpDraw03V2.vue?vue&type=script&lang=js&"
import style1 from "./MpDraw03V2.vue?vue&type=style&index=1&id=8904e1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8904e1c4",
  null
  
)

export default component.exports